export default __webpack_public_path__ + "static/media/msgsIcon.7751ad11.svg";